export const heatmapConstants = {
    GETALL_REQUEST: 'HEATMAP_GETALL_REQUEST',
    GETALL_SUCCESS: 'HEATMAP_GETALL_SUCCESS',
    GETALL_FAILURE: 'HEATMAP_GETALL_FAILURE',
}


// WEBPACK FOOTER //
// ./src/_constants/heatmap.constants.js